/**
 * Sol menünün bölüm filtreleri.
 *
 * Menü ağacı büyük (bu kurulumda ~180 ekran, 12 modül) ve her şey tek bir dikey akışta
 * duruyordu: dashboard'lar, favoriler ve modül ağacı alt alta. Aradığını bulmak için
 * ya kaydırmak ya da arama yazmak gerekiyordu.
 *
 * Bölümler VERİYE GÖRE oluşur, sabit bir liste değil: boş bölüm hiç gösterilmez.
 * Kurulumlar birbirine benzemiyor, sabit bir sekme listesi çoğunda boş dururdu.
 */
import type { UserScreenNode } from '@/shared/types/system';
import { isLeaf } from './useMenu';

export type MenuCategory = 'all' | 'favorites' | 'dashboards' | 'screens';

export interface CategoryCounts {
  favorites: number;
  dashboards: number;
  screens: number;
}

/** Ağacı düzleştirir; yalnızca açılabilir yapraklar (klasörler elenir). */
export function leafNodes(nodes: UserScreenNode[]): UserScreenNode[] {
  const out: UserScreenNode[] = [];
  const walk = (list: UserScreenNode[]) => {
    for (const n of list) {
      if (isLeaf(n)) out.push(n);
      if (n.children.length) walk(n.children);
    }
  };
  walk(nodes);
  return out;
}

/** Ekran adına göre sıralı düz liste (Türkçe sıralama) — düz liste gösteren bölümler için. */
export function sortByCaption(nodes: UserScreenNode[]): UserScreenNode[] {
  return nodes.slice().sort((a, b) => a.caption.localeCompare(b.caption, 'tr'));
}

/**
 * Hangi bölümler gösterilecek? "Tümü" her zaman var; diğerleri yalnızca içi doluysa.
 * "Ekranlar" bölümü ağaçta gezmeden alfabetik listeye bakmak isteyenler için, bu yüzden
 * ağaçta birden fazla kök varken anlamlı — tek modüllü kurulumda ağacın aynısı olurdu.
 */
export function visibleCategories(counts: CategoryCounts, rootCount: number): MenuCategory[] {
  const out: MenuCategory[] = ['all'];
  if (counts.favorites > 0) out.push('favorites');
  if (counts.dashboards > 0) out.push('dashboards');
  if (counts.screens > 0 && rootCount > 1) out.push('screens');
  return out;
}

/** Seçili bölüm artık görünmüyorsa (favori kalmadı gibi) "Tümü"ne düşülür. */
export function resolveCategory(selected: MenuCategory, visible: MenuCategory[]): MenuCategory {
  return visible.includes(selected) ? selected : 'all';
}
